// extracted by mini-css-extract-plugin
module.exports = {"outer":"styles_outer__Ft06m","inner":"styles_inner__oSjob"};